import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { numberWithCommas } from 'utils/numberFormatter';

const rangeMapper = (value) => {
  switch (value.toLowerCase()) {
    case 'daily':
      return 'Today';
    case 'weekly':
      return 'This Week';
    case 'monthly':
      return 'This Month';
    case 'all-time':
      return 'All Time';
    default:
      return '';
  }
}

const NumberMetricWrapper = ({
  isAverage,
  toggleMetricsConfig,
  comparisonInterval,
  timeRange,
  data,
  children,
}) => {
  const { count, title } = data;
  const valueText = isAverage
    ? `Average per ${comparisonInterval}`
    : rangeMapper(timeRange);

  return (
    <div className="p-3 w-100 d-flex flex-column justify-content-between">
      <div className="metrics-header d-flex flex-row justify-content-between">
        <div>{title}</div>
        <div className="cursor-pointer" onClick={() => toggleMetricsConfig(data)}>
          <FontAwesomeIcon icon="cog" />
        </div>
      </div>
      <div className="metrics-body text-center count">
        <div>{numberWithCommas(count)}</div>
        <div className="metric-value-text text-capitalize">
          {valueText}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};

NumberMetricWrapper.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    count: PropTypes.number,
  }),
  toggleMetricsConfig: PropTypes.func.isRequired,
  isAverage: PropTypes.bool,
  children: PropTypes.node,
  comparisonInterval: PropTypes.string,
  timeRange: PropTypes.string,
};

NumberMetricWrapper.defaultProps = {
  data: {
    title: '',
    count: 0,
  },
  isAverage: false,
  children: undefined,
  comparisonInterval: '',
  timeRange: '',
};

export default NumberMetricWrapper;



// WEBPACK FOOTER //
// ./src/components/dashboard/number/NumberMetricWrapper.js